"use client";
import {
  __async
} from "../../../chunk-MMUBH76A.js";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import styled from "styled-components";
import { InnerStepContainer, StepContainer, StyledCpslTileButton } from "../common.js";
import { CpslButton, CpslIcon, CpslSpinner, CpslText } from "@getpara/react-components";
import { OnRampStep, useModalStore, useThemeStore } from "../../stores/index.js";
import { useExternalWallets } from "../../providers/ExternalWalletContext.js";
import { useState } from "react";
import { ModalStep } from "../../utils/steps.js";
import { useWalletBalance } from "../../hooks/useWalletBalance.js";
import { formatBalanceString } from "../../utils/stringFormatters.js";
import { useInternalClient } from "../../../provider/hooks/utils/useInternalClient.js";
const Account = ({ onClose }) => {
  const onRampConfig = useModalStore((state) => state.onRampConfig);
  const setStep = useModalStore((state) => state.setStep);
  const setFlow = useModalStore((state) => state.setFlow);
  const setOnRampStep = useModalStore((state) => state.setOnRampStep);
  const hideWallets = useThemeStore((state) => state.hideWallets);
  const { disconnectExternalWallet } = useExternalWallets();
  const { balance, isLoading: isBalanceLoading } = useWalletBalance();
  const para = useInternalClient();
  const [isDisconnecting, setIsDisconnecting] = useState(false);
  const isOnRampLoaded = !!onRampConfig;
  const canBuyAndWithdraw = !!para.userId;
  const handleBuyClick = () => {
    setOnRampStep(OnRampStep.SETTINGS);
    setStep(ModalStep.ADD_FUNDS_BUY);
  };
  const handleReceiveClick = () => {
    setStep(ModalStep.ADD_FUNDS_RECEIVE);
  };
  const handleSellClick = () => {
    setOnRampStep(OnRampStep.SETTINGS);
    setStep(ModalStep.ADD_FUNDS_WITHDRAW);
  };
  const handleDisconnectClick = () => __async(void 0, null, function* () {
    setIsDisconnecting(true);
    yield disconnectExternalWallet();
    onClose();
    setStep(ModalStep.AUTH_MAIN);
    setFlow(void 0);
    setIsDisconnecting(false);
  });
  return /* @__PURE__ */ jsx(StepContainer, { $wide: true, children: /* @__PURE__ */ jsxs(InnerStepContainer, { children: [
    isBalanceLoading ? /* @__PURE__ */ jsx(BalanceContainer, { children: /* @__PURE__ */ jsx(CpslSpinner, { size: 39 }) }) : balance !== void 0 && /* @__PURE__ */ jsx(BalanceContainer, { children: /* @__PURE__ */ jsx(CpslText, { variant: "headingS", weight: "medium", children: formatBalanceString(balance) }) }),
    /* @__PURE__ */ jsx(ButtonContainer, { children: isOnRampLoaded ? /* @__PURE__ */ jsxs(Fragment, { children: [
      canBuyAndWithdraw && onRampConfig.isBuyEnabled && /* @__PURE__ */ jsx(OptionButton, { icon: "creditCard", onClick: handleBuyClick, children: /* @__PURE__ */ jsx(CpslText, { variant: "bodyXS", color: "secondary", weight: "medium", children: "Buy Crypto" }) }),
      onRampConfig.isReceiveEnabled && /* @__PURE__ */ jsx(OptionButton, { icon: "qrCode02", onClick: handleReceiveClick, children: /* @__PURE__ */ jsx(CpslText, { variant: "bodyXS", color: "secondary", weight: "medium", children: "Receive" }) }),
      canBuyAndWithdraw && onRampConfig.isWithdrawEnabled && /* @__PURE__ */ jsx(OptionButton, { icon: "arrowCircleBrokenDownLeft", onClick: handleSellClick, children: /* @__PURE__ */ jsx(CpslText, { variant: "bodyXS", color: "secondary", weight: "medium", children: "Withdraw" }) })
    ] }) : /* @__PURE__ */ jsx(CpslSpinner, {}) }),
    /* @__PURE__ */ jsx(DisconnectButton, { variant: "destructive", fullWidth: true, onClick: handleDisconnectClick, disabled: isDisconnecting, children: isDisconnecting ? /* @__PURE__ */ jsx(CpslSpinner, { size: 16 }) : /* @__PURE__ */ jsxs(Fragment, { children: [
      hideWallets ? "Logout" : "Disconnect Wallet",
      /* @__PURE__ */ jsx(CpslIcon, { icon: "logOut", slot: "end" })
    ] }) })
  ] }) });
};
const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  height: 88px;
`;
const OptionButton = styled(StyledCpslTileButton)`
  flex: 1;

  --button-icon-color: var(--cpsl-color-text-primary);
`;
const DisconnectButton = styled(CpslButton)`
  --button-border-width: 0px;
`;
const BalanceContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 8px;
  padding-bottom: 24px;
`;
export {
  Account
};
